import { render, staticRenderFns } from "./wikiFooter.vue?vue&type=template&id=3cab96c3"
import script from "./wikiFooter.vue?vue&type=script&lang=js"
export * from "./wikiFooter.vue?vue&type=script&lang=js"
import style0 from "./wikiFooter.vue?vue&type=style&index=0&id=3cab96c3&prod&lang=scss"
import style1 from "./wikiFooter.vue?vue&type=style&index=1&id=3cab96c3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports